import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import loading from '../../Callback/loading.svg';
import { connect } from 'react-redux';

class Success extends Component {
    render() {
        if (this.props.user.userProfile) {
            return <Redirect to={{
                pathname: "/rider",
                state: {
                    alert: {
                        show: true,
                        message: "You have successfully booked a ride!",
                        type: "success"
                    }
                }
            }} />
        }
        const style = {
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'white',
        }
        return (
            <div style={style}>
                <img src={loading} alt="loading"/>
            </div>
        )
    }
}

export default connect((state) => {
    return { user: state.reducerUser }
})(Success);